import { render, staticRenderFns } from "./CommunityBusinessnewsReply.vue?vue&type=template&id=39e38464"
import script from "./CommunityBusinessnewsReply.vue?vue&type=script&lang=js"
export * from "./CommunityBusinessnewsReply.vue?vue&type=script&lang=js"
import style0 from "./CommunityBusinessnewsReply.vue?vue&type=style&index=0&id=39e38464&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports